import { j as r } from "../../jsx-runtime-ClSzPYp4.js";
import { styled as e } from "styled-components";
import s from "../BaseIcon.mjs";
import a from "../IconSvgs/Caret.mjs";
const n = /* @__PURE__ */ e(s).withConfig({
  componentId: "sc-5d97befd-0"
})([
  "svg{transform:rotate(90deg);}"
]), f = ({ svgProps: o, ...t }) => /* @__PURE__ */ r.jsx(n, {
  svgProps: {
    "aria-label": "Caret pointing right",
    ...o
  },
  IconSvg: a,
  ...t
});
export {
  f as default
};
